import React from 'react';

import Pill, { PillProps } from '../Pill/Pill';
import { BasicInfoBox } from './VehicleCard';
import { InfoBoxChipsContainer, InfoBoxTitle, VehicleInfoBoxContainer } from './VehicleCard.styles';

export interface PillBox extends BasicInfoBox {
  title?: string;
  pill: PillProps;
}

const VehiclePillBox = ({ data, ...rest }: { data: PillBox }) => (
  <VehicleInfoBoxContainer $minWidth={data.minWidth} $maxWidth={data.maxWidth} {...rest}>
    {data.title && <InfoBoxTitle>{data.title}</InfoBoxTitle>}
    <InfoBoxChipsContainer>
      <InfoBoxChipsContainer>
        <Pill text={data.pill.text} variant="variant1" />
      </InfoBoxChipsContainer>
    </InfoBoxChipsContainer>
  </VehicleInfoBoxContainer>
);

export default VehiclePillBox;
